<template>
  <PageContainer title="Aulas Presenciais">
    <Box class="presenciais-container" space="medium">
      <div v-if="loading" class="d-flex justify-content-center">
        <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#1C2D5A'" :size="80" class="mx-2">
        </component>
      </div>

      <template v-else>
        <div class="table-container">
          <Paginate :total-pages="paginationData.lastPage" :current-page="paginationData.currentPage"
            @page-changed="fetchPresenciais" />

          <Table :headers="['Agrupamento', 'Início', 'Fim', 'Instrutor', 'Ações']">
            <tr v-if="!turmas.length">
              <td colspan="6">
                <div class="force-center">
                  Sem aulas presenciais
                </div>
              </td>
            </tr>
            <tr v-else v-for="turma in turmas" :key="turma.id_turma_teorica">
              <td>{{ turma.id_agrupamento }}</td>
              <td>{{ utils.formatDate(turma.data_inicio) }}</td>
              <td>{{ utils.formatDate(turma.data_fim) }}</td>
              <td>{{ turma.aulas[0].instrutor.nome }}</td>
              <td>
                <div class="actions">
                  <div>
                    <IconButton @handle:click="openModalInstrutor(turma)" color="primary" title="Presença instrutor"
                      :disabled="loadingActions">
                      <Webcam :size="19" />
                    </IconButton>
                  </div>
                  <div>
                    <IconButton @handle:click="openAlunosModal(turma)" color="primary" title="Informações dos alunos"
                      :disabled="loadingActions">
                      <AccountGroup :size="19" />
                    </IconButton>
                  </div>
                  <div>
                    <IconButton @handle:click="openPresencasModal(turma)" color="primary" title="Presenças"
                      :disabled="loadingActions">
                      <CameraOutline :size="19" />
                    </IconButton>
                  </div>
                </div>
              </td>
            </tr>
          </Table>
        </div>
      </template>
    </Box>

    <PhotoModal ref="photoModal" />

    <AlunosModal ref="alunoModal" />

    <PresencasModal ref="presencasModal" />
  </PageContainer>
</template>

<script>
import PageContainer from 'core/PageContainer'
import Box from 'core/Box'
import Table from 'core/Table'
import Paginate from 'core/Paginate'
import IconButton from 'core/IconButton'
import Modal from 'core/Modal'
import Button from 'core/Button'
import AccountOutline from 'icons/AccountOutline'
import AccountGroup from 'icons/AccountGroup'
import CameraOutline from 'icons/CameraOutline'
import Webcam from 'icons/Webcam'
import SendVariantOutline from 'icons/SendVariantOutline'

import PhotoModal from './PhotoModal'
import AlunosModal from "./AlunosModal"
import PresencasModal from "./PresencasModal"

import * as spinners from "epic-spinners"
import urlApi from '../../router/urlApi'
import utils from '../../services/utils'

export default {
  name: 'AulasPresenciais',
  components: {
    ...spinners,
    AccountOutline,
    AccountGroup,
    CameraOutline,
    Webcam,
    SendVariantOutline,

    PageContainer,
    Box,
    Table,
    Paginate,
    IconButton,
    Modal,
    Button,

    PhotoModal,
    AlunosModal,
    PresencasModal,
  },
  data() {
    return {
      utils: utils,
      cpf: '',
      typeSend: '',
      idTurmaTeorica: '',
      paginationData: {
        currentPage: 1,
        lastPage: 1,
        total: 1,
      },
      turmas: [],
      loading: false,
      loadingActions: false,
    }
  },
  async created() {
    await this.fetchPresenciais()

    this.getTurmasToday();
  },
  methods: {
    async fetchPresenciais() {
      this.loading = true

      await this.$http.get(`${urlApi}/turmas/presenciais/hoje`)
        .then(response => {
          this.turmas = response.body.dados
        })
        .catch(err => {
          this.$toasted.show('Erro ao buscar aulas.', {
            icon: 'fa-times',
            position: 'top-right',
          })
          this.$toasted.show(err.body.mensagem, {
            icon: 'fa-times',
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    async openModalInstrutor(turma) {
      const data = {
        cpf: turma.aulas[0].instrutor.cpf,
        typeSend: 'instrutor',
        idTurmaTeorica: turma.id_turma_teorica,
      }

      this.$refs.photoModal.open(turma.aulas[0].instrutor.nome, data)
    },
    openAlunosModal(turma) {
      this.$refs.alunoModal.open(turma)
    },
    openPresencasModal(idTurma) {
      this.$refs.presencasModal.open(idTurma)
    },
  }
}
</script>

<style lang="scss" scoped>
.presenciais-container {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  .table-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .pagination-container {
      align-self: flex-end;
    }

    .force-center {
      display: flex;
      justify-content: center;
    }

    .actions {
      display: flex;
      align-items: center;

      div {
        padding: 0 0.5rem;
        display: flex;
        justify-content: center;

        &:not(:first-child) {
          border-left: 1px solid #ECECEC;
        }

        &:not(:last-child) {
          border-right: 1px solid #ECECEC;
        }
      }
    }
  }
}
</style>
